import { render, staticRenderFns } from "./BusinessFlightsMainSection.vue?vue&type=template&id=407f5553"
import script from "./BusinessFlightsMainSection.vue?vue&type=script&lang=js"
export * from "./BusinessFlightsMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports